export default __webpack_public_path__ + "static/media/Beard_5_C2.6bc5b087.svg";